<template>
<div>
  <vs-row v-if="visibleTitle" class="mb-4">
    <vs-col><h5><i class="dot"></i>파일첨부</h5></vs-col>
  </vs-row>
  <vs-row class="mb-8">
    <vs-col class="flex">
      <vs-col class="w-auto pr-4">
        <vs-button class="" for="fileId" style="min-width:115px;" color="secondary" type="border" @click="handleClickAddFileButton" :disabled="readonly">{{$t('file_upload_module.파일첨부')}}</vs-button>
      </vs-col>
      <vs-col class="mb-2" style="border:1px solid #cdcdcd; border-radius: 8px;">
        <vs-col class="p-2  flex" style="border-bottom:1px solid #cdcdcd; border-top-left-radius: 8px; border-top-right-radius: 8px; ">
          <vs-checkbox v-model="allCheck" @change="handleChangeAllCheckBox">{{$t('file_upload_module.전체선택')}}</vs-checkbox>
          <a v-if="!readonly" class="ml-auto" href="javascript:;" @click="handleRemoveFile">{{$t('file_upload_module.선택삭제')}}</a>
        </vs-col>
        <vs-col class="p-2" style="height:120px; overflow-y: auto">
          <label style="cursor: pointer" class="flex" v-for="(file, index) in fileList" :key="index">
            <vs-checkbox class="mb-2 flex" v-model="fileSelect[file.id]" @change="()=>{ handleChangeCheckBox(file) }">
              <span>{{ file.fileName }}</span>
              <span class="ml-2" style="font-size:0.85rem; color:#cdcdcd;">({{file.fileSize}} bytes)</span>
            </vs-checkbox>
            <a :href="file.path" target="_blank" style="color:#6670CB">보기</a>
          </label>
        </vs-col>
        <vs-col class="p-2" style="border-top:1px solid #cdcdcd; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; background-color:#F9F9F9;">
          선택 {{ selectedFileInfo.length }}개 ({{selectFileSize}} Bytes), 전체 {{ fileList.length }}개 ({{totalFileSize}} Bytes)
        </vs-col>
      </vs-col>
    </vs-col>

  </vs-row>
</div>
</template>

<script>

export default {
  name: 'TemplateFileUploadCheckList',
  props: {
    fileList: {
      type: Array,
      default: ()=> {
        return [];
      }
    },
    visibleTitle: Boolean,
    readonly: Boolean
  },
  watch : {
    fileList () {
      this.initFileList(this.fileList)
      this.selectFileSize = this.getSelectFileSize()
    }
  },
  computed: {
    totalFileSize () {
      let totalFileSize = 0
      if (this.fileList) {
        for (const file of this.fileList) {
          totalFileSize += file.fileSize
        }
      }
      return totalFileSize
    }
  },
  data () {
    return {
      selectFileSize: 0,
      fileSelect: [], // 파일체크 여부 (v-model용)
      selectedFileInfo: [], //체크한 파일정보
      allCheck: false
    }
  },
  created () {
    this.initFileList(this.fileList)
  },
  methods:{

    initFileList (fileList) {
      const list = []
      for (const file of fileList) {
        list[file.id] = 0
      }
      this.fileSelect = list
    },

    getSelectFileSize () {
      let totalFileSize = 0
      for (const file of this.selectedFileInfo) {
        totalFileSize += file.fileSize
      }

      return totalFileSize
    },

    handleChangeAllCheckBox () {
      this.selectedFileInfo = []
      this.fileSelect = []
      this.selectFileSize = 0

      if (this.allCheck) {

        for (const file of this.fileList) {
          this.fileSelect[file.id] = true
          this.selectedFileInfo[this.selectedFileInfo.length] = file
          this.selectFileSize += file.fileSize
        }

      }
    },
    handleChangeCheckBox (file) {

      if (this.selectedFileInfo.indexOf(file) >= 0) {
        this.selectedFileInfo.remove(file)
      } else {
        this.selectedFileInfo[this.selectedFileInfo.length] = file
      }
      this.selectFileSize = this.getSelectFileSize()

      this.allCheck = (this.selectedFileInfo.length !== 0 && (this.selectedFileInfo.length === this.fileList.length))

    },
    handleClickAddFileButton () {
      this.$emit('handleClickAddFileButton')
    },

    handleChangeFile () {
      this.$emit('handleChangeFile')
    },

    handleRemoveFile () {
      this.$emit('handleRemoveFile', this.selectedFileInfo)
      this.selectedFileInfo = []
      this.selectFileSize = this.getSelectFileSize()
      this.allCheck = (this.selectedFileInfo.length !== 0 && (this.selectedFileInfo.length === this.fileList.length))
    }
  }
}
</script>

<style scoped>

</style>
